export default {"src":"/_next/static/media/icon_fresh.51e009cd.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};